import { Injectable } from '@angular/core';
import { DevicesService, InstalledApplication } from '@era/locations-sdk';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { mergeMap } from 'rxjs';
import {
  InstalledApplicationsResolverActions,
  InstalledApplicationsApiActions,
} from './device-installed-applications.actions';
import { safeMap } from '@era/stores';

@Injectable()
export class DeviceInstalledApplicationsStatusEffects {
  constructor(
    private readonly devicesService: DevicesService,
    private readonly actions$: Actions
  ) {}

  deviceInstalledApplicationsRequestedEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(InstalledApplicationsResolverActions.installedApplicationsRequested),
      mergeMap(({ brandId, locationId }) =>
        safeMap(
          this.devicesService.getInstalledApplicationsByLocation(brandId, locationId),
          (installedApplications: InstalledApplication[]) =>
            InstalledApplicationsApiActions.installedApplicationsLoaded({ installedApplications }),
          (error) => InstalledApplicationsApiActions.installedApplicationsLoadedError({ error })
        )
      )
    );
  });
}
